/**
 * Erstellt ein Container-Element für die Marker
 * 
 * @param element Array von Marker-Elementen
 */
export function mapMarkerContainer(element: HTMLElement[]): HTMLElement {
    // Erstelle ein Container-Element für die Marker
    const container = document.createElement('div');
    container.style.height = '15px';
    container.style.display = 'flex';

    // Füge jedes Element zum Container hinzu
    element.forEach(el => {
        container.appendChild(el);
    });

    container.style.cursor = 'pointer';
    return container;
}

/**
 * Erstellt ein Basis-Element für die Marker
 */
function mapMarkerBase(): HTMLElement {
    // Erstelle ein Basis-Element für die Marker
    const el = document.createElement('div');
    el.style.height = '100%';
    el.style.aspectRatio = '1/1'; // Setze das Seitenverhältnis auf 1:1
    el.style.opacity = '0.9';
    el.style.marginRight = '2px';
    return el;
}

export function mapMarkerStyleRed(): HTMLElement {
    // Erstelle ein rotes Marker-Element
    const el = mapMarkerBase();
    el.style.backgroundColor = '#a01737';
    return el;
}

export function mapMarkerStyleBlack(): HTMLElement {
    // Erstelle ein schwarzes Marker-Element
    const el = mapMarkerBase();
    el.style.backgroundColor = '#222222';
    return el;
}

export function mapMarkerStyle(style: string): HTMLElement {
    // Erstelle ein Marker-Element basierend auf dem übergebenen Stil
    switch (style) {
        case 'red':
            return mapMarkerStyleRed();
        case 'black':
        default:
            return mapMarkerStyleBlack();
    }
}